<template>
  <div class="re-reading">
    <div class="re-book text-center mb-16">
      <h1 class="dastnevis py-5">داستان کتاب را بخوانیم</h1>
      <FlipBook
        v-if="hasBookPage"
        class="flipbook"
        :pages="bookPages"
        :zooms="[1]"
        :perspective="3500"
        forward-direction="left"
        v-slot="flipbook"
      >
        <v-btn
          small
          depressed
          color="warning"
          class="mx-3"
          @click="flipbook.flipRight"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn
          small
          depressed
          color="warning"
          class="mx-3"
          @click="flipbook.flipLeft"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </FlipBook>
      <div class="mt-10" v-else>
        <v-alert>محتوایی برای نمایش وجود ندارد</v-alert>
      </div>
    </div>

    <MenuComponent :book-id="this.$route.params.id" state="reading" />
  </div>
</template>

<script>
import FlipBook from "v-flipbook";
import MenuComponent from "./Menu.vue";
export default {
  name: "reading-component",
  components: { FlipBook, MenuComponent },
  data() {
    return {
      bookPages: [""],
      hasBookPage: true
    };
  },
  created() {
    this.getPages();
  },
  methods: {
    getPages() {
      this.$api.get("/bookPages/" + this.$route.params.id).then((res) => {
        if (res.data.bookPages.length === 0) {
          this.hasBookPage = false;
        }
        res.data.bookPages.forEach((item) => {
          this.bookPages.push(
            "https://dl.pirls.ir/app/bookpages/" +
              item.book +
              "/" +
              item._id +
              ".jpg"
          );
        });
      });
    }
  }
};
</script>

<style>
.re-flipbook-box {
  max-width: 1000px;
}
.flipbook {
  width: 90%;
  height: 700px;
  margin: auto;
}
.flipbook img {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
</style>
